import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { printQuotedmgc3s3pgfors as printQuoted } from './StringOps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var JsonToStringWriterClass;
function JsonToStringWriter() {
  if (JsonToStringWriterClass === VOID) {
    class $ {
      constructor() {
        this.sb_1 = StringBuilder().new_kotlin_text_StringBuilder_wcb3z_k$(128);
      }
      writeLong_vk8q1z_k$(value) {
        this.sb_1.append_cu3spi_k$(value);
      }
      writeChar_9yrrvs_k$(char) {
        this.sb_1.append_58al37_k$(char);
      }
      write_mozxwr_k$(text) {
        this.sb_1.append_22ad7x_k$(text);
      }
      writeQuoted_k770v7_k$(text) {
        printQuoted(this.sb_1, text);
      }
      release_wu5yyf_k$() {
        this.sb_1.clear_1keqml_k$();
      }
      toString() {
        return this.sb_1.toString();
      }
    }
    initMetadataForClass($, 'JsonToStringWriter', JsonToStringWriter);
    JsonToStringWriterClass = $;
  }
  return JsonToStringWriterClass;
}
//region block: exports
export {
  JsonToStringWriter as JsonToStringWriter25agxcyem0yhk,
};
//endregion

//# sourceMappingURL=JsonToStringWriterJsWasm.mjs.map
